import * as types from '@/store/mutation-types.js';

export default {
    [types.SET_USER_INFO](state, userInfo) {
        state.userInfo = userInfo;
    },
    [types.SET_TOKEN](state, token) {
        state.token = token;
    },
    [types.SET_ASSOCIATION](state, association) {
        state.association = association;
    },
    [types.SET_PRE_ANSWERLIST](state, preAnswers) {
        state.preAnswers = preAnswers;
    },
}
